/**
 * Core – Auth (login, sign up, forgot password, activation, 2FA)
 */

export default {
  login: {
    signIn: "Sign In",
    signOut: "Sign Out",
    or: "or",
    createAcc: "create an account",
    email: "Email",
    password: "Password",
    rememberMe: "Remember me",
    forgotPass: "Forgot your password?",
    err: "Error",
    invalidEmail: "Invalid email",
    enterPassAndEmail: "Please enter your password and email",
  },
  auth: {
    login: {
      welcomeBack: "Welcome back!",
      pageTitle: "Log In",
      dontHaveAccount: "Don't have an account?",
      signUp: "Sign up",
      emailOrPasswordIncorrect: "Email or password is incorrect",
      hidePassword: "Hide password",
      showPassword: "Show password",
    },
    twoFa: {
      title: "Sign in using your authenticator app",
      pageTitle: "Two-Factor Authentication",
      codeLabel: "Enter your 6-digits verification code from Authenticator",
      codePlaceholder: "6-digits code",
      backToSignIn: "← Back to sign in options",
      continue: "Continue",
      wrongVerificationCode: "Wrong verification code. Please try again.",
    },
  },
  signUp: {
    signIn: "Sign In",
    connectErr: "Connection error",
    invalidEmail: "Invalid email",
    enterName: "Please enter name",
    enterSurname: "Please enter surname",
    enterCompany: "Please enter company name",
    enterPhone: "Please enter phone",
    enterCountry: "Please enter country",
    phoneMust: 'The phone number must start with "+" and consist of digits',
    email: "Email",
    country: "Country",
    name: "Name",
    surname: "Surname",
    companyName: "Company Name",
    companyEmail: "Company Email",
    sameAsLogin: "Same as Login",
    phone: "Phone",
    signUp: "Sign Up",
    finishReg: "Finish Registration",
    weSent1:
      "We've sent you email with instruction to follow. If you didn't recieve it, we can",
    weSent2: "resend a new email",
    haveAcc: "Have an account?",
  },
  forgotPassword: {
    signIn: "Sign In",
    email: "Email",
    password: "Password",
    invalidEmail: "Invalid email",
    enterEmail: "Please enter email",
    connectErr: "Connection error",
    passNotMatch: `Passwords don't match`,
    enterPass: "Please enter password",
    repeatPass: "Please repeat the password",
    passRecovery: "Password Recovery",
    backTo: "Back to",
    recover: "Recover",
    weSent1:
      "We'we sent you email with instruction to follow. If you didn't recieve it, we can",
    weSent2: "resend a new email",
    finishPassRec: "Finish Password Recovery",
    newPass: "New password",
    repPass: "Repeat password",
    recLinkInvalid: "Password recovery link is invalid or expired.",
    passChanged: "Password has been successfully changed",
    passLeast: "Your password must be at least 7 characters",
  },
  activation: {
    signIn: "Sign In",
    userActivation: "User Activation",
    activationInProcess: "Please wait. Activation is in process.",
    linkInvalid: "Activation link is invalid or expired.",
  },
  invite: {
    invalidInvite: "Invalid Invite",
    invalidOrExpired: "This invite is invalid or expired.",
    checkingInvite: "Checking invite…",
    wrongAccountLogin: "Wrong account?",
    logInInstead: "Log in",
    instead: "instead",
    joinAccountTitle: "Join an account",
    cancel: "Cancel",
    joinAccount: "Join account",
    processing: "Processing...",
    continue: "Continue",
    continueSigningUp: "Continue signing up",
    or: "or",
    loading: "Loading...",
    continueWithGoogle: "Continue with Google",
  },
};
